import { render, staticRenderFns } from "./AutoWidthOption.vue?vue&type=template&id=3d57b72f"
import script from "./AutoWidthOption.vue?vue&type=script&lang=js"
export * from "./AutoWidthOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d57b72f')) {
      api.createRecord('3d57b72f', component.options)
    } else {
      api.reload('3d57b72f', component.options)
    }
    module.hot.accept("./AutoWidthOption.vue?vue&type=template&id=3d57b72f", function () {
      api.rerender('3d57b72f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/import-export/AutoWidthOption.vue"
export default component.exports